import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo, useState } from "react";
import { SharePrivateClipLinkInfo } from "~/components/SharePrivateClipModal/SharePrivateClipLinkInfo";
import { SharePrivateClipSettings } from "~/components/SharePrivateClipModal/SharePrivateClipSettings";
import { SharePrivateContentTabs } from "~/components/SharePrivateContentModal/SharePrivateContentTabs";
export const SharePrivateClipTabs = /*#__PURE__*/ memo((param)=>{
    let { clip, shortIdInfo, trackLocation, boardContext } = param;
    const [activeTab, setActiveTab] = useState("link");
    const panels = useMemo(()=>{
        return [
            {
                id: "link",
                label: "Link",
                content: /*#__PURE__*/ _jsx(SharePrivateClipLinkInfo, {
                    shortIdInfo: shortIdInfo,
                    clip: clip,
                    trackLocation: trackLocation,
                    goToSettings: ()=>setActiveTab("settings"),
                    boardContext: boardContext
                })
            },
            {
                id: "settings",
                label: "Settings",
                content: /*#__PURE__*/ _jsx(SharePrivateClipSettings, {
                    clipId: clip.id,
                    shortIdInfo: shortIdInfo
                })
            }
        ];
    }, [
        boardContext,
        clip,
        shortIdInfo,
        trackLocation
    ]);
    return /*#__PURE__*/ _jsx(SharePrivateContentTabs, {
        setActiveTab: setActiveTab,
        activeTab: activeTab,
        panels: panels
    });
});
SharePrivateClipTabs.displayName = "SharePrivateClipTabs";
